import { makeStreamPosition } from '@engoo/realtime-protocol/persisted';
// There will only ever be one chat image modal open at a time, so they can share the
// position value for the chat keypath when syncing expanded image state
export const EXPANDED_IMAGE_PATH_KEY = makeStreamPosition(0);
